export const sortByKey = <T>(
  array: T[],
  key: keyof T,
  descending: boolean = false
): T[] => {
  return array.sort((a, b) => {
    const valA = a[key];
    const valB = b[key];

    if (typeof valA === 'string' && typeof valB === 'string') {
      return descending ? valB.localeCompare(valA) : valA.localeCompare(valB);
    }
    if (typeof valA === 'number' && typeof valB === 'number') {
      return descending ? valB - valA : valA - valB;
    }
    // Handle other types or throw an error if necessary
    return 0;
  });
};
